import React from 'react';
import List from '@mui/material/List';
import Waiting from './../items/Waiting';
import ContentContainer from './../items/ContentContainer';
import TrackListContainer from './../items/TrackListContainer';

function TrackListScroller(props) {

  const waitingRender = () => { 
    if (props.isWaiting) {
      return <Waiting />;
    }
  };

  return (
    <ContentContainer id={props.id} onScrollDown={props.onScrollDown} isFinished={props.isFinished} isSongbook={props.isSongbook} isCatalog={props.isCatalog}>
      <List className="muvika-track-list-scroller-list">
        <TrackListContainer highlight={props.highlight} isOnFavoritesView={props.isOnFavoritesView} isBackgroundMusic={props.isBackgroundMusic} isSongbook={props.isSongbook} isNewTracks={props.isNewTracks} tracks={props.tracks} />
        {waitingRender()}
      </List>
    </ContentContainer>
  );
}

export default TrackListScroller;